<nav class="navbar navbar-expand bg-light navbar-light sticky-top px-4 py-0">
    <a routerLink="/home" class="navbar-brand d-flex d-lg-none me-4">
        <h2 class="text-primary mb-0"><i class="fa fa-hashtag"></i></h2>
    </a>
    <a (click)="open()" class="sidebar-toggler flex-shrink-0">
        <i class="fa fa-bars"></i>
    </a>
    <div class="navbar-nav align-items-center ms-auto">
        <div class="nav-item dropdown">
            <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown">
                <img class="rounded-circle me-lg-2" src="../assets/img/defaultuser.png" alt="" style="width: 40px; height: 40px;">
                <span class="d-none d-lg-inline-flex">{{user}}</span>
            </a>
            <div class="dropdown-menu dropdown-menu-end bg-light border-0 rounded-0 rounded-bottom m-0">
                <a href="/myprofile" class="dropdown-item">Mi Perfil</a>
                <a (click)="salir()" class="dropdown-item">Salir</a>
            </div>
        </div>
    </div>
</nav>